@let showLabel = props.label && !props.hideLabel;

<div *ngIf="showLabel">
  <label [attr.for]="id">
    {{ props.label }}
    <small *ngIf="fileSize">{{ fileSize | formatSize }} </small>
    <small *ngIf="fileType">{{ fileType }}</small>
    <span *ngIf="props.required && !props.hideRequiredMarker">*</span>
  </label>
</div>

<div class="file-card-body" [class.invalid-feedback]="hasErrors">
  <label [ngClass]="{'file-over': hasDropZoneOver}" class="well my-drop-zone">
    <nb-icon icon="upload-outline"/>
    {{ fileName }} <span *ngIf="props.required && !showLabel && !file">*</span>
    <input (change)="onFileSelect($event)" type="file" [attr.accept]="accept || null" [multiple]="isMultiple" style="display: none"/>
  </label>

  <div class="my-drop-zone-info">
    @if (!hasErrors) {
      @if (fileSize > 0) {
        {{ fileSize | formatSize }}
      } @else if (!props.fileOptions?.hideDescription) {
        <div *ngIf="props.description">{{ props.description }}</div>
        <div *ngIf="maxFileSize" i18n="@@MaxFileSize">Максимальный размер файла {{ maxFileSize | formatSize }}</div>
      }
    } @else {
      <formly-validation-message [field]="field"/>
    }
  </div>
</div>

<div *ngIf="false" class="debug-info">
  {{ formControl.errors | json }}
</div>
